import { AlgAttivazioniService } from './../../../services/alg-attivazioni.service';
import { Attivazione } from '../../../models/attivazione';
import { Component, OnInit, Input } from '@angular/core';
import { Observable } from 'rxjs/Observable';

@Component({
  selector: 'alg-attivazioni-contract-hero',
  templateUrl: './alg-attivazioni-contract-hero.component.html',
  styleUrls: ['./alg-attivazioni-contract-hero.component.scss'],
})
export class AlgAttivazioniContractHeroComponent {
  @Input() reverse: boolean;
  public attivazione: Attivazione;
  public productName: string = '';
  public productName$: Observable<string>;
  constructor(private consensoService: AlgAttivazioniService) {
    this.productName$ = this.consensoService.attivazioneProductName$;
  }

  ngOnInit() {
    this.consensoService.attivazione$
      .subscribe((attivazione) => {
        if (!attivazione) {
          return;
        }
        this.attivazione = attivazione;
      });
    if (this.attivazione.product.lightRate) {
      this.productName = `${this.attivazione.product.family} ${this.attivazione.product.type} ${this.attivazione.product.lightRate}`
    } else {
      this.productName = `${this.attivazione.product.family} ${this.attivazione.product.type}`
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/alg-attivazioni/alg-attivazioni-contract-hero/alg-attivazioni-contract-hero.component.ts